import { Component, CUSTOM_ELEMENTS_SCHEMA, input, InputSignal } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { EndLocationMainComponent } from "./components/end-location-main/end-location-main.component";
import { RegularMainComponen } from "./components/regular-main/regular-main.component";

@Component({
  selector: 'app-main',
  standalone: true,
  imports: [
    TranslateModule,
    EndLocationMainComponent,
    RegularMainComponen
],
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class MainComponent {
  public isLocationCard: InputSignal<boolean> = input.required<boolean>();
  public id: InputSignal<number> = input.required<number>();
  public title: InputSignal<string> = input.required<string>(); // TODO: CAMBIAR A OBJETO DE TRADUCCIONES
  public indexCard: InputSignal<number> = input.required<number>();
  public startDate: InputSignal<Date> = input.required<Date>();
  public durationMinutes: InputSignal<number> = input.required<number>();
  public isDuration15Minutes: InputSignal<boolean> = input.required<boolean>();
}
